module.exports = __webpack_public_path__ + "static/media/OSDserie460.bfd6371e.jpg";